import React from 'react';

import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    icon: IconKey;
    title: string;
    description: string;
}

const AboutListItem = ({ icon, title, description }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex items-center gap-x-3">
            <div className="relative flex size-12 items-center justify-center rounded-full bg-gray-100 text-gray-600">
                <Icon iconKey={icon} />
            </div>

            <div>
                <p className="font-bold">{i18next.t(title)}</p>

                <p className="text-gray-500">{i18next.t(description)}</p>
            </div>
        </div>
    );
};

export default AboutListItem;
